import React from 'react';
import { Modal } from 'antd';
import Register from '../pages/Register';

interface RegisterModalProps {
    open: boolean;
    onClose: () => void;
}

const RegisterModal: React.FC<RegisterModalProps> = ({ open, onClose }) => {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width="80%"
            height={"80%"}
        >
            <Register onClose={onClose}/>
        </Modal>
    );
};

export default RegisterModal;
